import { CLINIC_MAP_DIRECTIONS_URL } from './clinic';

export const SITE_URL = 'https://dynamicdentalclinic.com';
export const SITE_NAME = 'Dynamic Dental Clinic';

/** Canonical URL for prerendered detail routes (folder index.html → trailing slash). */
export function articleUrl(slug: string): string {
  return `${SITE_URL}/articles/${slug}/`;
}

export function serviceUrl(slug: string): string {
  return `${SITE_URL}/services/${slug}/`;
}

export function galleryUrl(slug: string): string {
  return `${SITE_URL}/gallery/${slug}/`;
}

/** In-app router paths (trailing slash matches prerendered folders). */
export function articlePath(slug: string): string {
  return `/articles/${slug}/`;
}

export function servicePath(slug: string): string {
  return `/services/${slug}/`;
}

export function galleryPath(slug: string): string {
  return `/gallery/${slug}/`;
}
export const ORGANIZATION_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo192.png`;
export const OG_BANNER_IMAGE = `${SITE_URL}/bannerImage.png`;

export const CLINIC_SOCIAL_PROFILES = [
  'https://www.facebook.com/profile.php?id=61578773662595',
  'https://www.instagram.com/_dynamicdental_',
  'https://youtube.com/@dynamicdental-m4',
  'https://www.linkedin.com/company/wwwdynamicdental/about/',
  CLINIC_MAP_DIRECTIONS_URL,
  SITE_URL,
] as const;

export const HOME_OG = {
  title: 'Dynamic Dental Clinic | Professional Dental Care in Lalitpur',
  description:
    'Expert dental care in Lalitpur, Nepal. We provide teeth cleaning, dental implants, orthodontics, smile makeovers, and emergency dental services.',
  url: `${SITE_URL}/`,
  image: OG_BANNER_IMAGE,
  imageAlt: 'Dynamic Dental Clinic in Lalitpur, Nepal',
  imageWidth: '1200',
  imageHeight: '630',
};

export const SEO_PAGES = {
  home: {
    title: 'Best Dentist in Lalitpur, Nepal | Dynamic Dental Clinic',
    description:
      'Looking for a trusted dentist in Lalitpur, Nepal? Dynamic Dental offers teeth cleaning, dental implants, orthodontics, and emergency dental care.',
    keywords:
      'dental clinic in lalitpur, dental clinic near me lalitpur, dental clinic in nepal, dentist Kumaripati, teeth cleaning, dental implants, orthodontics, emergency dentist, Dynamic Dental Clinic',
    canonicalUrl: `${SITE_URL}/`,
    ogTitle: HOME_OG.title,
    ogDescription: HOME_OG.description,
    ogImage: HOME_OG.image,
    ogUrl: HOME_OG.url,
  },
  services: {
    title: 'Dental Services in Lalitpur, Nepal | Dynamic Dental Clinic',
    description:
      'Explore dental services at Dynamic Dental in Lalitpur - teeth cleaning, implants, orthodontics, root canals, whitening, crowns, and emergency care. Book online.',
    keywords:
      'dental services Lalitpur, teeth cleaning Nepal, dental implants, orthodontics, root canal, teeth whitening, emergency dentist Nepal',
    canonicalUrl: `${SITE_URL}/services/`,
  },
  articles: {
    title: 'Dental Health Articles & Blog | Dynamic Dental Clinic Nepal',
    description:
      'Read expert dental health articles from Dynamic Dental in Lalitpur, Nepal. Tips on oral hygiene, implants, orthodontics, and preventive dental care.',
    keywords:
      'dental blog Nepal, dental articles Lalitpur, oral health tips, dentist blog Nepal, dental clinic articles',
    canonicalUrl: `${SITE_URL}/articles/`,
  },
} as const;

export const CLINIC_SCHEMA = {
  name: SITE_NAME,
  alternateName: 'Dynamic Dental',
  description:
    'Dynamic Dental Clinic in Kumaripati, Lalitpur, Nepal offers teeth cleaning, dental implants, orthodontics, and emergency dental care.',
  url: SITE_URL,
  image: DEFAULT_OG_IMAGE,
  telephone: '+977-984-0354608',
  email: 'info@dynamicdentalclinic.com',
  address: {
    streetAddress: 'above Global IME Bank, Kumaripati',
    addressLocality: 'Lalitpur',
    addressRegion: 'Bagmati',
    postalCode: '44700',
    addressCountry: 'NP',
  },
  geo: {
    latitude: 27.671391,
    longitude: 85.312154,
  },
  openingHours: [
    { dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '10:00', closes: '18:00' },
  ],
  priceRange: '$$',
  sameAs: [...CLINIC_SOCIAL_PROFILES],
};
